module.exports = __webpack_public_path__ + "static/pic01-5c6efd984e19c8c528835b1715d90269.png";